"use client";

import { c as _c } from "react-compiler-runtime";
import { useConsentGate as useConsentGateShared } from "@/features/assessments/consent/useConsentGate";
type UseConsentGateOptions = {
  onCancel: () => void;
  trackConsent: () => void;
  onConsentAccepted?: () => void | Promise<void>;
};
export function useConsentGate(t0) {
  const $ = _c(4);
  const {
    onCancel,
    trackConsent,
    onConsentAccepted
  } = t0;
  const t1 = onConsentAccepted ?? _temp;
  let t2;
  if ($[0] !== onCancel || $[1] !== t1 || $[2] !== trackConsent) {
    t2 = {
      onCancel,
      trackConsent,
      onConsentAccepted: t1
    };
    $[0] = onCancel;
    $[1] = t1;
    $[2] = trackConsent;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return useConsentGateShared(t2);
}
function _temp() {}